/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useStreamBankFileDrop} from "../../../../../Hooks/useStreamBankFileDrop";
import {useEditContextNodeId} from "../../../../../Hooks/PermissionHooks";
import React, {Fragment, useEffect} from "react";
import {Button, Container} from "react-bootstrap";
import {Glyphicon} from "../../../../Common/GlyphIcon";
import {ContextNodeLink} from "../../../../Common/ContextNodeLink";

export const ProjectImportArea = (props) => {
    const {
        contextNodeId,
        className,
        queuedFiles = {},
        uploadedFiles = [],
        setUploadedFiles = (uploadedFiles) => {},
    } = props;
    
    const {
        getRootProps,
        fileUploadComponents,
        lastChanged,
        showFilePicker
    } = useStreamBankFileDrop(
            contextNodeId,
            {
                onSuccess: setUploadedFiles,
                tagCode: "project_import",
                acceptedFileTypes: ".yaml",
            }
        );
    
    const editContextNodeId = useEditContextNodeId();
    
    useEffect(() => {
        // this means the file was uploaded
    }, [lastChanged]);
    
    return <div className="sb-project-import-area" {...getRootProps()}>
        <Fragment>
            {fileUploadComponents}
        </Fragment>
        <Container className={className}>
            {
                uploadedFiles.length ?
                <Fragment>
                    <div key="files-list-header-row" className="row h3">
                        Import the following files?
                    </div>
                    <div key="files-list-row" className="row">
                        <ul key="import-files-list" className="sb-file-upload-list">
                            {uploadedFiles?.map((file, index) => {
                                const queuedFile = queuedFiles?.[file?.fileUploadId];
                                return <li key={queuedFile?.fileUploadId ?? `index-${index}`} className="sb-file-upload-item">
                                    <div className="sb-file-upload-item">
                                        <div key="filename">
                                            <div className="title">{file?.fileName}</div>
                                            <div className="content">
                                                {
                                                    queuedFile?.error ? null :
                                                        (queuedFile?.targetContextNodeId ?
                                                        <ContextNodeLink contextNodeId={queuedFile?.targetContextNodeId}/> :
                                                            "New Project"
                                                        )
                                                }
                                            </div>
                                        </div>
                                        <div key="message">
                                            { queuedFile?.error ? <div className="error">{queuedFile?.error ?? null }</div> : null }
                                            { queuedFile?.message ? <div className="message">{queuedFile?.message ?? null }</div> : null }
                                        </div>
                                    </div>
                                </li>;
                            })}
                        </ul>
                    </div>
                </Fragment>
                :
                <Fragment>
                    <div className="row text-center h3">
                        Drag and drop files here, or click Select File(s) to import them.
                    </div>
                    <div className="row text-center" key="import-files">
                        <Button variant="link" className="float-right h4" onClick={showFilePicker}>
                            <Glyphicon glyph="plus-sign">Select File(s)</Glyphicon>
                        </Button>
                    </div>
                </Fragment>
            }
        </Container>
    </div>;
};
